import bioPhoto from './../assets/images/IMG_0049.jpg';
import DynamicBibleQuote from "../components/DynamicBibleQuote/DynamicBibleQuote";
import PromoImageView from "../components/PromoImageView/PromoImageView";
import ShortBio from "../components/ShortBio/ShortBio";

const HomePage = () => {
  return (
    <div className="HomePage text-center">
      <div className="flex p-2 m-auto text-left max-w-screen-2xl flex-wrap lg:flex-nowrap justify-center">
        <div className="lg:p-8 flex flex-col sm:flex-row lg:flex-col">
          <img src={bioPhoto} className="bio-photo" alt="Lauri" />
          <div className="flex-1"></div>
          <div className="text-center mt-8 sm:mt-0 lg:mt-8 block xl:hidden">
            <iframe
              title="Spotify"
              src="https://open.spotify.com/embed/artist/1gksgycDNzFiSND7NG58Vx"
              width="300"
              height="380"
              frameBorder="0"
              allow="encrypted-media"
            />
          </div>
        </div>
        <div className="flex-1 max-w-xl">
          <div className="p-4 md:p-8">
            <ShortBio />
          </div>
        </div>
        <div className="text-center hidden xl:block -mt-20 relative">
          <iframe
            className="shadow-2xl bg-gray-900"
            title="Spotify"
            src="https://open.spotify.com/embed/artist/1gksgycDNzFiSND7NG58Vx"
            width="360"
            height="456"
            frameBorder="0"
            allow="encrypted-media"
          />
        </div>
      </div>
      <div className="bg-red-900 p-8 text-white">
        <DynamicBibleQuote />
      </div>
      <PromoImageView />
    </div>
  )
};

export default HomePage;